import React from 'react'

export default function Interiors() {
    return (
        <div>
            <h1>Hello from Interiors Component</h1>
        </div>
    )
}